import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import Avatar from "../../components/common/AvtarImage";
import Button from "../../components/common/Button";
import CompanyIcon from "../../assets/images/company-icon.png";
import CompanyLocationIcon from "../../assets/images/company-location-icon.png";
import dots from "../../assets/svg/dots.svg";
import Report from "../../components/common/Report";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { rootReducersState } from "../../reducers";
import { saveJobRequest } from "../../reducers/candidate/candidate.reducer";
import appRoutes from "../../routes/app.routes";
import { ReactComponent as Save } from "../../assets/svg/save.svg";
import { ReactComponent as SaveActive } from "../../assets/svg/save-active.svg";
import { ReactComponent as Applied } from "../../assets/svg/applied.svg";
import { ReactComponent as Screening } from "../../assets/svg/screening.svg";
import { ReactComponent as Qualfied } from "../../assets/svg/qualified.svg";
import { ReactComponent as Rejected } from "../../assets/svg/rejected.svg";
import { ReactComponent as Contacted } from "../../assets/svg/contacted.svg";
import { ReactComponent as Interviewed } from "../../assets/svg/interviewed.svg";
import { ReactComponent as Hired } from "../../assets/svg/hired.svg";
import { openUrlInNewTab } from "./../../utils/helper";

import {
  REMOTE_CHOICE,
  companyApplicationStatuses,
} from "../../utils/appConstants";
import { truncate } from "../../utils/helper";
import { Box, Typography } from "@material-ui/core";

interface JobCardsProps {
  job: any;
  saved?: boolean;
  applicationStatus?: number;
  rejectionReason?: string;
  onRemove?: (id: number) => void;
  noButton?: boolean;
  jobHubDescription?: boolean;
  showStatus?: boolean;
  isJobHub?: boolean;
  setIsSavedChanged?: React.Dispatch<React.SetStateAction<boolean>>;
}

const statusIcons: any = {
  applied: <Applied />,
  screening: <Screening />,
  qualified: <Qualfied />,
  rejected: <Rejected />,
  contacted: <Contacted />,
  interviewed: <Interviewed />,
  hired: <Hired />,
};

const JobCards: React.FC<JobCardsProps> = ({
  job,
  applicationStatus,
  onRemove,
  noButton,
  showStatus,
  isJobHub,
  setIsSavedChanged,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const session = useSelector((state: rootReducersState) => state.session);
  const token = _.get(session, "token", null);
  const currentUserId = _.get(session, "currentUser.id", "");
  const [isSaved, setIsSaved] = useState(
    job.saved === 1 || job.saved_status === 1
  );
  const jobReferenceId = _.get(job, "id") || _.get(job, "job_id") || _.get(job, "jobId");

  const [showMenu, setShowMenu] = useState<number | null>(null);
  const [openReport, setOpenReport] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setShowMenu(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const getCandidateJobStatus = () => {
    return (
      Object.values(companyApplicationStatuses).find(
        (obj: any) => obj.id === applicationStatus
      ) || { id: 0, title: "applied" }
    );
  };

  const handleRouting = () => {
    openUrlInNewTab(appRoutes.jobDetail.generatePath(_.get(job, "slug", "")));
  };

  const handleSave = (e: any, id: number) => {
    e.stopPropagation();
    dispatch(saveJobRequest(id));
    setIsSaved(true);
    if (setIsSavedChanged) setIsSavedChanged(true);
  };

  const handleUnsave = (e: any, id: number) => {
    e.stopPropagation();
    dispatch(saveJobRequest(id));
    setIsSaved(false);
    if (setIsSavedChanged) setIsSavedChanged(false);
    if (onRemove) onRemove(id);
  };

  const toK = (num: number) => {
    if (!num) return num;

    if (num >= 1000) {
      const val = (num / 1000).toFixed(1);
      return val.replace(/\.0$/, "") + "k";
    }

    return num + "k";
  };

  return (
    <>
      <Box
        className="job-card-wrapper"
      >
        <Box className="card-upper">
          <Box className="job-image">
            <Avatar src={_.get(job, "va_company_logo", "")} type="job" />
          </Box>

          <Box className="job-info cursor-pointer" onClick={handleRouting}>
            <Typography variant="h5">
              {truncate(_.get(job, "title", "Untitled Job"), 22)}
            </Typography>
            <Box className="job-description">
              <Box className="company-info">
                <img src={CompanyIcon} alt="Company Icon" />
                {_.get(job, "company_name", "Unknown Company")}
              </Box>

              <Box className="company-info">
                <img src={CompanyLocationIcon} alt="Company Location Icon" />
                {_.get(job, "city.location", "Location N/A")}
              </Box>
            </Box>
          </Box>

          <div
            className="feed-header-more"
            ref={menuRef}
            onClick={(e) => {
              e.stopPropagation();
              setShowMenu(showMenu === jobReferenceId ? null : jobReferenceId);
            }}
          >
            {token && (
              <Box className="save-icon" onClick={(e) => e.stopPropagation()}>
                {isSaved ? (
                  <SaveActive
                    onClick={(e) => handleUnsave(e, jobReferenceId)}
                  />
                ) : (
                  <Save onClick={(e) => handleSave(e, jobReferenceId)} />
                )}
              </Box>
            )}
            <img src={dots} alt="menu" className="dot-icon" />

            {showMenu === jobReferenceId && (
              <Box className="menu" component="ul">
                <Box
                  component="li"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!currentUserId) navigate(appRoutes.userLogin.path);
                    else setOpenReport(true);
                  }}
                >
                  Report Job
                </Box>
              </Box>
            )}
          </div>
        </Box>

        <Box className="card-botttom">
          {!isJobHub && (
            <Box className="job-tags">
              <Box className="tag">{_.get(job, "job_type_title", "N/A")}</Box>
              <Box className="tag">
                {REMOTE_CHOICE.find(
                  (x) => x.value === _.get(job, "is_remote", 1)
                )?.label || "On-site"}
              </Box>
              <Box className="tag">
                {job.currency?.symbol ? job.currency?.symbol : job.currency?.symbol}{" "}
                {job.salary_term === "annual"
                  ? `${toK(job.min_salary)} -
              ${toK(job.max_salary)} / `
                  : `${job.min_salary} -
              ${job.max_salary} / `}
                {job.salary_term === "annual" ? "Annual" : "Hour"}
              </Box>
            </Box>
          )}
          <Box className="job-footer">
            <Typography component="span" variant="caption">
              {_.get(job, "posted_on", "N/A")}
              <Box component="span" className="dot" />
              {_.get(job, "totalApplicants", 0)} Applicants
            </Typography>
            {showStatus &&
              (() => {
                const status = getCandidateJobStatus();
                const key = status.title.toLowerCase();

                return (
                  <Box className="status">
                    <Box className="label">
                      {statusIcons[key] || <Applied />}
                      <label className={key}>{status.title}</label>
                    </Box>
                  </Box>
                );
              })()}
            {!noButton && (
              <Button className="view-more-btn" onClick={handleRouting}>
                View More
              </Button>
            )}
          </Box>
        </Box>
      </Box>

      {openReport && (
        <Report
          referenceId={String(jobReferenceId || "")}
          type="jobs"
          openReports={true}
          onClose={() => setOpenReport(false)}
        />
      )}
    </>
  );
};

export default JobCards;
